import { ScanProgress } from 'fitbeat.models';
import React from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, ScrollView, StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { default as BodyscaleInfo } from './bodyscale-info';
import { BodyscaleAccordionSectionInfo } from './bodyscale-info';

interface IProps {
    bodyComposition: string;
    progress: ScanProgress;
    phase: string;
    t: (key: string) => string;
    showBodyGroups(): void;
}

class BodyscaleScanProgress extends React.PureComponent<IProps, any> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const { t, bodyComposition, showBodyGroups } = this.props;
        return (
            <View style={styles.container}>
                <ScrollView contentContainerStyle={{flexGrow: 1}}>
                <View style={{flex: 1, justifyContent: 'flex-end', marginBottom: defaultScale(25) }}>
                    <View style={{justifyContent: 'center', flex: 1}}>
                        <Text style={styles.scanDescriptionText}>
                            {this.props.progress === ScanProgress.Inprogress ?
                                `${t('scanInProgress')} ${this.props.phase}` :
                                t('tryingScaleConnect')}
                        </Text>
                            <ActivityIndicator
                                size='large'
                                animating={true}
                                color={Theme.PRIMARY}
                                style={styles.activityIndicator}
                            />
                        <Text style={[styles.scanInstructionText, { color: Theme.PRIMARY }]}>
                            {this.props.progress === ScanProgress.Inprogress ? t('stayOnScale') : t('stepOnScale')}
                        </Text>
                    </View>
                    <BodyscaleInfo
                        bodyComposition={bodyComposition}
                        showBodyGroups={showBodyGroups}
                        bodyscaleAccordionSections={[
                            BodyscaleAccordionSectionInfo.INSTRUCTIONS,
                            BodyscaleAccordionSectionInfo.TOUBLESHOOTING,
                          ]}
                        activeSection={0}
                    />
                </View>
                </ScrollView>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    scanDescriptionText: {
        color: Theme.GREY_DARK_MEDIUM,
        fontSize: 22,
        fontFamily: Theme.Custom500,
        letterSpacing: 0,
        lineHeight: 20,
        marginTop: defaultScale(25),
        alignSelf: 'center',
    },
    scanInstructionText: {
        fontSize: 26,
        fontFamily: Theme.Custom800,
        alignSelf: 'center',
        textAlign: 'center',
    },
    activityIndicator: {
        padding: 38,
    },
});

export default translate(['bodyscan'])(BodyscaleScanProgress);
